import { ADD_OBSERVATION, CLEAR_OBSERVATION } from '../../mutation-types';

const mutations = {
  [ADD_OBSERVATION](state, { observation, protocol }) {
    state.observation.set(protocol, observation);
  },

  [CLEAR_OBSERVATION](state, protocol) {
    state.observation.delete(protocol);
  },
};

export default mutations;
